angular.module('SpidApp')

.factory('Stamp', [function () {
	var Stamp = function (params) {
		this.code_pays          = params.code_pays
		this.label_pays         = params.label_pays
		this.label_affran       = params.label_affran
		this.restriction_affran = params.restriction_affran
		this.code_affran        = params.code_affran
		this.prix_comp          = params.prix_comp
		this.poids_comp         = params.poids_comp
		this.poids_max          = params.poids_max
		this.prix               = params.prix
		this.label_service      = params.label_service
		this.prix_service       = params.prix_service
		this.service_code       = params.service_code
	}
	
	Stamp.types = {
		SIMPLE : 'Vignette simple'
	}

	return Stamp
}])